import React, { useEffect, useState } from "react";
import { Form } from "../../../components/forms";
import dayjs from "dayjs";
import * as Yup from "yup";
import CallbackTimeSelector from "./CallbackTimeSelector";
import DatePickerInput from "./DatePickerInput";

const EditAppointmentPopup = ({ show, onClose, dateSlots, selectedDay, availableAppointments }) => {
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [showTimeSlots, setShowTimeSlots] = useState(false);
  const [firstSubmit, setFirstSubmit] = useState(false);
  const [availableSlots, setAvailableSlots] = useState();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const result = availableAppointments?.reduce((acc, { datetime }) => {
      const date = new Date(datetime).toISOString().split('T')[0];
      const time = new Date(datetime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(time);

      return acc;
    }, {});

    setAvailableSlots(result)

  }, [availableAppointments])

  useEffect(() => {
    setSelectedDate(selectedDay?.split("T")[0])
    setSelectedTime(localStorage.getItem("appointment_time"))
  }, [selectedDay])

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    setIsMobile(isMobile);
  }, []);

  const handleDateChange = (event) => {
    setSelectedDate(dayjs(event).format('YYYY-MM-DD'));
    setSelectedTime("");
  };

  const handleTimeChange = (value) => {
    setSelectedTime(value);
    setShowTimeSlots(false)
  }

  if (!show) return null;

  const validationSchema = Yup.object().shape({});

  const formatWithSuffix = (dateString) => {
    const date = dayjs(dateString);
    const day = date.format("D");
    const month = date.format("MMMM");

    const daySuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${daySuffix(day)} ${month}`;
  };

  const handleSubmit = async (values) => {
    setFirstSubmit(true)
    const selectedAppointment = availableAppointments?.find(
      data => data.datetime.split('T')[0] === selectedDate && dayjs(data.datetime).format("hh:mm A").toUpperCase() === selectedTime
    )
    localStorage.setItem("appointment_id", selectedAppointment?.id || "-")
    localStorage.setItem("appointment_date", formatWithSuffix(selectedAppointment?.datetime) || "-")
    localStorage.setItem("appointment_time", selectedTime || "-")
    localStorage.setItem("appointment_full_date", dayjs(selectedAppointment?.datetime).format('DD/MM/YYYY hh:mm A') || "-")
    onClose();
  }

  return (
    <Form
      validationSchema={validationSchema}
      initialValues={{
        date: selectedDay?.split("T")[0],
      }}
      enableReinitialize
      className="d-flex"
      onSubmit={((selectedTime !== "-" && selectedTime !== "") && selectedDate !== undefined) && handleSubmit}
      validate={() => setFirstSubmit(true)}
    >
      <div onClick={() => setShowTimeSlots(false)} className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 popup">
        <div className="bg-white rounded p-4 pb-5 shadow-lg inner-box">
          <div className="d-flex flex-row align-items-center justify-content-between mx-1 mx-md-4">
            <h5 className="text-primary-600 mb-0 fw-bold">
              {localStorage.getItem("appointment_date") !== "-" && localStorage.getItem("appointment_time") !== "-" ? "Change" : "Select"} appointment date & time
            </h5>
            <button
              onClick={onClose}
              className="d-flex bg-transparent border-0 align-items-center"
            >
              <img
                src="/images/vectors/close-circle.svg"
                alt="close"
                className="google-icon"
              />
            </button>
          </div>
          <hr className="hr-popup mt-4 mb-5" />
          <div className="d-flex flex-column gap-7 justify-content-between h-75">
            <div className="modal-body mx-1 mx-md-4">
              <div className="container px-0 d-flex flex-column justify-content-between">
                <div className="column col-md-12">
                  <label className="mb-2">
                    Appointment date<span className="text-red-1">*</span>
                  </label>
                  <DatePickerInput
                    name="date"
                    onChange={handleDateChange}
                    minDate={new Date()}
                    maxDate={
                      dateSlots.length > 0 ? new Date(dateSlots[dateSlots.length - 1]) :
                        new Date()}
                    defaultValue={selectedDate && new Date(selectedDate)}
                  />
                  {(selectedDate === "" || selectedDate === undefined) && firstSubmit && (
                    <label className="text-danger mt-1">
                      Appointment date is required
                    </label>
                  )}
                </div>
                <div className="column col-md-12 mt-4 cursor-pointer">
                  <label className="mb-2">
                    Appointment time<span className="text-red-1">*</span>
                  </label>
                  {!isMobile && (
                    <div
                      className="d-flex justify-content-between align-items-center p-2 px-3 fs-6 bg-transparent border card-border rounded custom-placeholder"
                      onClick={
                        (e) => {
                          e.stopPropagation();
                          setShowTimeSlots(!showTimeSlots)
                        }}
                    >
                      <p className="mb-0">{selectedTime || "Select time"}</p>
                      <img src={`/images/vectors/clock.svg`} alt="" style={{ width: "18px" }} />
                    </div>
                  )}
                  {(showTimeSlots && !isMobile) && (
                    <CallbackTimeSelector
                      selectedDate={selectedDate}
                      callbackTime={selectedTime}
                      setCallbackTime={handleTimeChange}
                      availableSlots={availableSlots}
                      limit={4}
                      isCustomSlots={true}
                    />
                  )}
                  {isMobile && (
                    <CallbackTimeSelector
                      selectedDate={selectedDate}
                      callbackTime={selectedTime}
                      setCallbackTime={handleTimeChange}
                      availableSlots={availableSlots}
                      isCustomSlots={true}
                    />
                  )}
                  {((selectedTime === "" || selectedTime === "-") && firstSubmit && !showTimeSlots) && (
                    <label className="text-danger mt-1">
                      Appointment time is required
                    </label>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer mx-1 mx-md-4">
              <button
                className="bg-primary-600 text-white py-2 px-5 w-fit h-fit fw-bold fs-6 border-0 rounded text-nowrap"
                type="submit"
              >
                Confirm Date
              </button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default EditAppointmentPopup;
